module.exports = __webpack_public_path__ + "media/images/icon/arrows-9c71044e109f6e9f33a0183d293f2eaa.png";